<script setup>

import HomeHero from "@/pages/HomePage/HomeHero.vue";
import HomeFeaturedYachts from "@/pages/HomePage/HomeFeaturedYachts.vue";
import HomeDestinations from "@/pages/HomePage/HomeDestinations.vue";
import HomeFeaturedArticles from "@/pages/HomePage/HomeFeaturedArticles.vue";
import { usePageSEO } from '@/composables/usePageSEO'


usePageSEO('')
</script>

<template>
  <HomeHero/>
  <div id="scroll-to-home">
    <HomeFeaturedYachts />
    <HomeDestinations />
    <HomeFeaturedArticles />
  </div>
</template>

<style scoped>

</style>
